const dataSourcesModules = {
  'ConsumptionDataSource': 'consumptionDataSource.js',
  'PaymentsDataSource': 'paymentsDataSource.js',
  'AbonentCardDataSource': 'abonentCardDataSource.js',
  'ConsumptionInfoDataSource': 'consumptionInfoDataSource.js',
  'RequestsDataSource': 'requestsDataSource.js',
  'ClaimedFactBDataSource': 'claimedFactBDataSource.js',
  'ClaimedConsumptionBDataSource': 'claimedConsumptionBDataSource.js',
  'InvoiceFileLastDataSource': 'invoiceFileLastDataSource.js',
  'ClaimedFactADataSource': 'claimedFactADataSource.js',
  'ClaimedPlanADataSource': 'claimedPlanADataSource.js',
  'ChatBotDataSource': 'ChatBotDataSource.js',
  'FileLoaderDataSource': 'fileLoaderDataSource.js'
}
  
function InitDataSources(dataSources) {
  let obj = {}
  if (dataSources) {
    for (const ds of dataSources) {
      obj[ds.Name] = () => import('./DataSourceModel')
    }
  }
  
  for (const module of Object.keys(dataSourcesModules)) {
    obj[module] = () => import('./items/' + dataSourcesModules[module])
  }
  return obj
}
  
export default InitDataSources